import { serviceAssignmentRoutes } from "@modules/ServiceAssignment/config/routes";
import { authRoutes } from "@modules/Authentication/config/routes";
import { subscriptionsRoutes } from "@modules/Subscriptions/config/routes";
import { serviceFeesRoutes } from "@modules/ServiceFees/config/routes";
import { paymentProcessingRoutes } from "@modules/PaymentProcessing/config/routes";
import { purchasingRoutes } from "@modules/Purchasing/config/routes";
import { serviceProcessingRoutes } from "@modules/ServiceProcessing/config/routes";
import i18n from "@I18n/services/i18n";
import messages from "./messages";
import { serviceRequestRoutes } from "@modules/ServiceRequest/config/routes";

const appRoutes = {
  HOME: "/",
  ROOT: "/",
  ABOUT: "about",
  SERVICE_PROVIDER_LANDING: "become-a-service-provider",
  REQUEST_SERVICE: "task_creation",
  BECOME_SERVICE_PROVIDER: "become-a-service-provider",
  BEST_SERVICE_PROVIDERS: "rankings",
  SHARE: "share_friends",
  HOW_IT_WORKS: "howitworks",
  PRICING: "pricing",
  SHARING_ECONOMY_LAW: "legal_sharing_economy",
  CONTACT_US: "contact_us",
  HELP_CENTER: "help_center",
  TEAM: "team",
  CAREERS: "workforus",
  PRESS: "press_room",
  BLOG: "https://blog.ringtwice.be/",
  PARTNERS: "partners",
  TERMS: "/condgen",
  SITEMAP: "sitemap",
  FACEBOOK: "https://www.facebook.com/ringtwice.be",
  TWITTER: "https://twitter.com/RingTwiceBe",
  INSTAGRAM: "https://www.instagram.com/ringtwice.be/",
  VIMEO: "https://vimeo.com/ringtwice",
  LINKEDIN: "https://www.linkedin.com/company/ringtwicebe",
  APPLE_STORE_DOWNLOAD:
    "https://apps.apple.com/be/app/ring-twice/id1357150375?l=nl",
  GOOGLE_PLAY_STORE_DOWNLOAD:
    "https://play.google.com/store/apps/details?id=be.listminut.app",
  USERS: "users",
  SERVICE_OFFERS: "contracts",
  FEATURE_FLAGS_ADMIN: "/feature_flags/admin/features",
  NOT_FOUND: "404",
  SERVER_ERROR: "500",
  LEGACY_SERVICE_REQUEST: "tasks/:id",
  TERMS_AND_CONDITIONS: "terms-and-conditions",
  NEW_RATING: i18n.formatMessage(messages.sp_evaluations_url),
  SUPERTALENT_OBJECTIVES: "supertalent_objectives",
  REALISATION_RATE: "realisation_rate",
  REPEAT_RATE: "repeat_rate",
  AVERAGE_RATING: "evaluations",
  JOBS_CLOSED: "jobs?type=closed",
  SERVICE_PROVIDER_PROFILE: "listworkers/:id",
  CANCELLATIONS: "cancellations",
  CHART_URL: i18n.formatMessage(messages.chart_url),
  SUPER_TALENT_URL: i18n.formatMessage(messages.super_talent_url),
  ACADEMY_RECURRENCY: i18n.formatMessage(messages.academy_recurrency),
  ACADEMY_REALISATION: i18n.formatMessage(messages.academy_realisation),
  INSTANT_MATCHING_URL: i18n.formatMessage(messages.instant_matching_url),
  PHOTO_BOOK: "listworkers/profil/portfolio",
  CLIENT_DASHBOARD: "home_listposter",
  LEGACY_SERVICE_REQUEST_EDIT: "experiment/tasks/:id/edit",
  LEGACY_HAS_CONTRACT_TASK_CANCEL: "cancel_task_by_user_with_contracts",
  LEGACY_NO_CONTRACT_TASK_CANCEL: "cancel_task_by_user",
  CHANGE_EMAIL: "change_email",
  CHANGE_EMAIL_FROM_DASHBOARD: "dashboard?open_email=true",
};

export default {
  ...appRoutes,
  ...serviceAssignmentRoutes,
  ...authRoutes,
  ...subscriptionsRoutes,
  ...serviceFeesRoutes,
  ...paymentProcessingRoutes,
  ...purchasingRoutes,
  ...serviceProcessingRoutes,
  ...serviceRequestRoutes,
};
